import { DEFAULT_NODE_NEAR_VIEWPORT_MARGIN } from "../core/consts";

/**
 * Checks if an element is in the current viewport or within the provided margin above or below
 * the viewport.
 *
 * The margin is the distance from the top or bottom of the viewport to the element in
 * pixels. For the top of the viewport, the element bottom is compared to the top of the viewport
 * minus the margin. For the bottom of the viewport, the element top is compared to the bottom of
 * the viewport plus the margin.
 *
 * @param element The HTML element to check
 * @param margin The margin in pixels to check above or below the viewport.
 * @returns True if the element is within the viewport and provided margin, false otherwise.
 */
export function isElementNearViewport(
  element: HTMLElement | null,
  margin: number = DEFAULT_NODE_NEAR_VIEWPORT_MARGIN,
): boolean {
  if (!element) {
    return false;
  }

  const { top, bottom } = element.getBoundingClientRect();

  return bottom > -margin && top < window.innerHeight + margin;
}
